module.exports = __webpack_public_path__ + "static/img/img-shop-order-logistics.be5e38fb.png";